import assetPath from '/app/packages/lebenslauf/components/src/assets/ibm-plex-mono-bold.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')